import { Phone, Mail } from "lucide-react";
import { CONTACT, LOGO_URL, NAV_LINKS, scrollToId } from "@/data/content";

export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="bg-[#0B192C] text-slate-300 border-t border-[#C5A059]/20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="inline-block bg-[#FBF9F5] rounded-xl px-6 py-4">
              <img src={LOGO_URL} alt="Trivena Exim LLP logo" className="h-16 w-auto" />
            </div>
            <p className="mt-6 font-serif text-2xl text-white tracking-tight">Trivena Exim LLP</p>
            <p data-testid="footer-tagline" className="mt-2 text-sm text-slate-400 tracking-wide">
              Import • Export • Logistics • Trade Solutions
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.24em] font-semibold text-[#C5A059]">
              Navigate
            </p>
            <nav className="mt-5 flex flex-col gap-3" aria-label="Footer">
              {NAV_LINKS.map((link) => (
                <button
                  key={link.id}
                  data-testid={`footer-link-${link.id}`}
                  onClick={() => scrollToId(link.id)}
                  className="w-fit text-sm text-slate-300 hover:text-[#C5A059] transition-colors duration-300"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] uppercase tracking-[0.24em] font-semibold text-[#C5A059]">
              Contact
            </p>
            <div className="mt-5 space-y-3">
              <a
                data-testid="footer-phone-link"
                href={CONTACT.phoneHref}
                className="flex items-center gap-3 text-sm text-slate-300 hover:text-[#C5A059] transition-colors duration-300"
              >
                <Phone className="w-4 h-4 text-[#C5A059]" strokeWidth={1.8} />
                {CONTACT.phone}
              </a>
              <a
                data-testid="footer-email-link"
                href={`mailto:${CONTACT.email}`}
                className="flex items-center gap-3 text-sm text-slate-300 hover:text-[#C5A059] transition-colors duration-300"
              >
                <Mail className="w-4 h-4 text-[#C5A059]" strokeWidth={1.8} />
                {CONTACT.email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p data-testid="footer-copyright" className="text-xs text-slate-500 tracking-wide">
            © 2026 Trivena Exim LLP. All Rights Reserved.
          </p>
          <p className="text-xs text-slate-600 tracking-[0.2em] uppercase">
            Connecting Businesses · Moving Possibilities
          </p>
        </div>
      </div>
    </footer>
  );
}
